import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  {
    label: 'Habilitado',
    value: 'enabled'
  },
  {
    label: 'Habilitado, com anexo obrigatório',
    value: 'enabled_but_file_is_required'
  }
]

export const strategy = optionsToStrategy(options)
